export default {
    // called by Vue.use(FirstPlugin)
    install(Vue, options) {
      // create a mixin
      Vue.prototype.$getRouting = function (routeName, additionalParams = null, query = null) {
        let params = {}
        let routing = {
          name: routeName,
        }

        if(routeName !== 'content-page'){
          params.path = this.$t('route.'+routeName)
        } else {
          additionalParams.path = this.$t('route.'+additionalParams.path)
        }

        if(additionalParams !== null) {
          params = {
            ...additionalParams,
            ...params
          }
        }

        routing.params = params

        if(query !== null) {
            routing.query = query
        }

        return routing
      };

      Vue.prototype.$goTo = function (routeName, additionalParams = null, query = null) {

        let paramString = '', queryData = {}, path = ''

        if(routeName !== 'content-page'){
          path = this.$t('route.'+routeName)
        } else {
          additionalParams.path = this.$t('route.'+additionalParams.path)
        }

        if(additionalParams !== null) {
          for (const [key, value] of Object.entries(additionalParams)) {
            paramString = `${paramString}/${value}`
          }
        }

        if(query !== null) {
          for (const [key, value] of Object.entries(query)) {
            query[key] = value
          }
        }

        if (this.$router?.currentRoute?.name !== path) {
            this.$router.push({path: `/${path}${paramString}`, query: query})
        }
      };

      Vue.prototype.$getUrl = function (routeName, additionalParams = null, query = null) {
        let paramString = '', queryData = '', queryCounter = 0, path = ''

        if(routeName !== 'content-page'){
          path = this.$t('route.'+routeName)
        } else {
          additionalParams.path = this.$t('route.'+additionalParams.path)
        }

        if(additionalParams !== null) {
          for (const [key, value] of Object.entries(additionalParams)) {
            paramString = `${paramString}/${value}`
          }
        }

        if(query !== null) {
          for (const [key, value] of Object.entries(query)) {
            if(queryCounter === 0) {
              queryData = `?${key}=${value}`
            } else if (value != '') {
              queryData = `${queryData}&${key}=${value}`
            }

            queryCounter++
          }
        }

        if(routeName !== 'content-page') {
          return `/${path}${paramString}${queryData}`
        }

        return `${path}${paramString}${queryData}`
      };
    },
  };
